<template v-on:scroll.native="handleScroll">
  <v-container fluid class="pa-0" >
    <v-card
    flat
    >

    <!-- top app bar -->
    <v-app-bar
    class="bar"
    flat
    >
    <v-toolbar-title>Messages</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
  </v-app-bar>

  <!-- messages -->
  <v-list two-line flat>
    <v-list-item-group
    multiple
    :key="stuff"
    >
    <template v-for="message in fetchMessages">
      <v-list-item :key="message.id">

        <!-- message avatar -->
        <v-list-item-avatar>
          <v-img :src="message.from =='me' ? user.profilePic : otherUserDetails.profilePic"></v-img>
        </v-list-item-avatar>

        <!-- message content -->
        <v-list-item-content>
          <v-list-item-subtitle v-text="(message.from =='me' ? user.username : otherUserDetails.username) + ' | ' + message.date"></v-list-item-subtitle>
          <v-list-item-title v-text="message.text" ></v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text ></v-list-item-action-text>

        </v-list-item-action>
      </v-list-item>


    </template>
  </v-list-item-group>
</v-list>
</v-card>

<!-- message text box -->
<v-footer
app
height="80%"
padless
inset
color="white"
elevation="5"
>
<v-container class="pa-0">
  <v-row class="d-flex">
    <v-col lg="8">
      <v-form>
        <v-text-field
        @keydown.enter.prevent="addCategory"
        v-model="message"
        :prepend-icon="icon"
        outlined
        clear-icon="mdi-close-circle"
        clearable
        full-width
        label="Message"
        type="text"
        @click:append="toggleMarker"
        @click:append-outer="sendMessage"
        @click:prepend="changeIcon"
        @click:clear="clearMessage"
        @keyup.enter="sendMessage"
        dense
        ></v-text-field>
      </v-form>
    </v-col>

    <v-col lg="1" class="ml-n4">
      <v-btn @click="sendMessage" icon color="teal" large>
        <v-icon>mdi-send</v-icon>
      </v-btn>
    </v-col>
    <!-- select message life -->
      <v-col cols="2" class="pa-0">
        <v-select
          v-model="select"
          :hint="`${select.state}`"
          :items="items"
          item-text="state"
          label="Select"
          persistent-hint
          return-object
          single-line
        ></v-select>
      </v-col>

  </v-row>
</v-container>
</v-footer>
</v-container>
</template>

<script>
import { mapState, mapActions} from 'vuex'
import Vue from 'vue'
var counter = 10;
var loadMore = true;
export default {
  props:['id'],
  data: () => ({
    stuff: 0,
    drawerRight: false,
    show: false,
    message: '',
    marker: true,
    iconIndex: 0,
    icons: [
      'mdi-emoticon',
      'mdi-emoticon-cool',
      'mdi-emoticon-dead',
      'mdi-emoticon-excited',
      'mdi-emoticon-happy',
      'mdi-emoticon-neutral',
      'mdi-emoticon-sad',
      'mdi-emoticon-tongue',
    ],
    select: { state: 'Forever'},
        items: [
          { state: 'Forever'},
          { state: '5 mins'},
          { state: '1 hour'},
          { state: '1 day'},
          { state: '1 week'},
          { state: '1 month'},
        ],
  }),
  computed: {
    ...mapState(['user']),
    otherUserDetails() {
      return this.$store.state.allUsers[this.id]
    },
    fetchMessages() {
      //this.$store.dispatch('firebaseDecrypt',this.id)
      return this.$store.state.fetchMessages
    },
    icon () {
      return this.icons[this.iconIndex]
    },
  },
  methods: {
    ...mapActions(['getPukey','getMoreMessage','firebaseGetMessages', 'firebaseSendMessage', 'firebaseStopGettingMessages', 'firebaseDisappearMessages']),
    toggleMarker () {
      this.marker = !this.marker
    },
    sendMessage () {
      if(this.message !== ''){
        let toDelete
        if(this.select.state === 'Forever'){
          toDelete= 'Forever'
        }
        else if(this.select.state === '5 mins') {
          toDelete= new Date()
          toDelete.setMinutes(toDelete.getMinutes() + 5)
        }
        else if(this.select.state === '1 hour') {
          toDelete= new Date()
          toDelete.setMinutes(toDelete.getMinutes() + 60)
        }
        else if(this.select.state === '1 day') {
          toDelete= new Date()
          toDelete.setDate(toDelete.getDate() + 1)
        }
        else if(this.select.state === '1 week') {
          toDelete= new Date()
          toDelete.setDate(toDelete.getDate() + 7)
        }
        else if(this.select.state === '1 month') {
          toDelete= new Date()
          toDelete.setMonth(toDelete.getMonth() + 1)
        }
        this.firebaseSendMessage({
          message: {
            text: this.message,
            from: 'me',
            date:''+ new Date(),
            timeDelete: '' + toDelete
          },
          otherUserId:this.id
        })
        this.clearMessage()
      }
    },
    handleScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      var body= document.body;
      var docElem= document.documentElement;
      docElem= (docElem.clientHeight)? docElem: body;
      if (docElem.scrollTop == 0){
        this.loadMore()
      }
    },
    clearMessage () {
      this.message = ''
    },
    changeDate(date) {
      if(date !== undefined){
       return date.toLocaleString()
      }
      // return date
    },
    resetIcon () {
      this.iconIndex = 0
    },
    changeIcon () {
      this.iconIndex === this.icons.length - 1
      ? this.iconIndex = 0
      : this.iconIndex++
    },
    loadMore(){
      if(loadMore === this.id){
        this.$store.state.fetchMessages = {}
        counter+=25
        const data = {
          friendId: this.id,
          count: counter
        }
        this.firebaseGetMessages(data)
      }
    }
  },
  mounted() {
    counter = 10;
    loadMore = this.id
    document.addEventListener('scroll', this.handleScroll)
    window.scrollTo(0,document.body.scrollHeight);
    const data = {
      friendId: this.id,
      count: counter
    }
    this.getPukey(this.id)
    this.firebaseGetMessages(data)
    this.firebaseDisappearMessages(this.id)
    this.$store.dispatch('firebaseSeenNotification', this.id)
    this.$store.dispatch('firebaseGetNotifications')
  },
  destroyed() {
    this.firebaseDisappearMessages(this.id)
    this.firebaseStopGettingMessages(this.id)
    this.$store.dispatch('firebaseSeenNotification', this.id)
    this.$store.dispatch('firebaseGetNotifications')
    loadMore = false
  }
}
</script>

<style lang="css" scoped>
</style>
